import { Component, Input } from '@angular/core';

import { IconName, IconComponent, IconColorDirective } from '@recruitee/user-interface';

@Component({
  selector: 'rt-wysiwyg-inline-button',
  templateUrl: './wysiwyg-inline-button.component.html',
  styleUrls: ['./wysiwyg-inline-button.component.less'],
  host: {
    '(click)': '$event.preventDefault()',
    '[class.active]': 'active',
    '[class.invalid]': 'status?.invalid',
    '[class.dropdown-open]': 'dropdownOpen',
  },
  standalone: true,
  imports: [IconColorDirective, IconComponent],
})
export class WysiwygInlineButtonComponent {
  @Input() public icon: IconName;
  @Input() public dropdownOpen: boolean;
  @Input() public active: boolean;
  @Input() public status: { invalid: boolean; message: string };

  @Input() public clipboardValue: string;
  @Input() public displayValue: string;
}
